import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';

const CheckboxInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
  error,
  setError,
  validateInput,
  hasTriedSubmitting,
}) => {
  //Effect to initialise checkbox with empty string when no user input
  useEffect(() => {
    if (!userInput) handleInputChange(fileIndex, tagIndex, '');
  }, []);

  //Effect to validate user input on submit
  useEffect(() => {
    if (hasTriedSubmitting > 0) validateInput(userInput);
  }, [hasTriedSubmitting]);

  //Effect to monitor changesin input
  useEffect(() => {
    if (userInput.length != 0) setError('');
  }, [userInput]);

  const handleCheckboxChange = (value, isChecked) => {
    let updatedItems = userInput;
    if (isChecked) {
      updatedItems += updatedItems ? `,${value}` : value;
    } else {
      updatedItems = updatedItems
        .split(',')
        .filter((item) => item !== value)
        .join(',');
    }
    handleInputChange(fileIndex, tagIndex, updatedItems);
  };

  const isCheckboxChecked = (value) => {
    return userInput?.split(',').includes(value);
  };

  return (
    <>
      <Form.Check className="photo-uploader__image-list-form-check">
        {metaTag.list.map((checkboxElement, index) => (
          <div key={id + '_' + index}>
            <Form.Check.Label>
              <Form.Check.Input
                value={userInput}
                checked={isCheckboxChecked(checkboxElement)}
                id={metaTag.meta.id}
                onChange={(e) => {
                  handleCheckboxChange(checkboxElement, e.target.checked);
                  setError('');
                }}
                name="metaTag.meta.id"
              />{' '}
              {checkboxElement}
            </Form.Check.Label>
          </div>
        ))}
      </Form.Check>
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default CheckboxInput;
